import { DisplayHours } from "components/display/hours";
import { calculateTotalHoursWithConsumptionFactor } from "components/timesheet/utils";

export const UtilizationCell = (info) => {
  const original = info.row?.original || {};
  const allocated = Array.isArray(original.allocated_hours)
    ? original.allocated_hours
    : [];
  const timesheet = Array.isArray(original.timesheet) ? original.timesheet : [];

  const allocatedTotal = allocated.reduce(
    (sum, entry) => sum + (Number(entry?.hours) || 0),
    0
  );

  const loggedTotal = calculateTotalHoursWithConsumptionFactor(
    timesheet,
    "logged_hours"
  );

  // Show bucket_job_config.hours for bucket jobs, allocated_hours for others
  const displayHours = original.type === "bucket"
    ? (original.bucket_job_config.hours || 0)
    : allocatedTotal;

  return (
    <div>
      <DisplayHours value={loggedTotal} /> / {" "}
      {displayHours ? <DisplayHours value={displayHours} /> : "-"}
    </div>
  );
};
